import { Card, Form } from 'ui';
import type { GivingScopeEnum } from '..';
import { Navigation } from '../navigation';
import { GivingsListContent } from './givings-list-content';
import { GivingsListFilters, type GivingsListFiltersFormValues } from './givings-list-filters';

type FormValues = GivingsListFiltersFormValues;

type P = {
  getPathToGivingDetail: (id: string) => string;
  navigateToGiveNow: () => Promise<void>;
  navigateToGivingBrowse: () => Promise<void>;
  scope: GivingScopeEnum;
};

const initialValues: Partial<FormValues> = {
  type: 'all',
};

const GivingsList = ({ getPathToGivingDetail, navigateToGiveNow, navigateToGivingBrowse, scope }: P) => (
  <>
    <Navigation navigateToGiveNow={navigateToGiveNow} navigateToGivingBrowse={navigateToGivingBrowse} scope={scope} />
    <Card>
      <Form<FormValues> initialValues={initialValues} noOptional>
        <GivingsListFilters />
        <Form.Item<FormValues> dependencies={['search', 'organization', 'type']} noStyle>
          {({ getFieldsValue }) => {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
            const { organization, search, type } = getFieldsValue(true) as Partial<FormValues>;

            return (
              <GivingsListContent
                filter={{
                  organization,
                  search,
                  type: type === 'all' ? undefined : type,
                }}
                getPathToGivingDetail={getPathToGivingDetail}
              />
            );
          }}
        </Form.Item>
      </Form>
    </Card>
  </>
);

export default GivingsList;
